import { AsyncStateNotification } from '@ui/notifications';
import { coreActions } from '@sonar-software/sonar-core';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { createAsyncSelectors, createSonarSelector } from '@lib/selectors';
import { Form, Switch } from 'antd';
import { NOTIFICATION_PREFERENCES_COPY, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { useAction, useAsyncStateWithPreload, useCurrentUser } from '@hooks';
const selectors = createAsyncSelectors((state) => state.core.users.byId.notificationPrefs.get);
const patchStateSelector = createSonarSelector((state) => state.core.users.byId.notificationPrefs.patch);
export const NotificationPreferences = () => {
    const { id: userId } = useCurrentUser();
    const { isRequested, data } = useAsyncStateWithPreload(selectors, coreActions.requestGetCoreUsersByIdNotificationPreferences, true, { userId });
    const patchPreferences = useAction(coreActions.requestPatchCoreUsersByIdNotificationPreferences);
    const handleMentionChange = useCallback((value) => {
        patchPreferences({
            allowMentionEmails: value,
            userId
        });
    }, [patchPreferences, userId]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: 'notification-preferences' },
            React.createElement(LoadingSpinner, { spinning: isRequested },
                React.createElement(Form, { colon: false },
                    React.createElement(Form.Item, { className: 'horizontal-form-item', label: NOTIFICATION_PREFERENCES_COPY.EMAIL_WHEN_AT_MENTIONED, name: 'allowMentionEmails' },
                        React.createElement(Switch, { checked: data === null || data === void 0 ? void 0 : data.allowMentionEmails, onChange: handleMentionChange }))))),
        React.createElement(AsyncStateNotification, { errored: NOTIFICATIONS_COPY.ERROR_PATCH_USER_PREFERENCES, failed: NOTIFICATIONS_COPY.FAILED_PATCH_USER_PREFERENCES, received: NOTIFICATIONS_COPY.SUCCESS_PATCH_USER_PREFERENCES, resetRawAction: coreActions.resetPatchCoreUsersByIdNotificationPreferences, stateSelector: patchStateSelector })));
};
